export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI2MWQzODlkNGY1YzQ0ODE0NDMwNTdkMTJkMmU5NWU0ZiIsIm5iZiI6MTczMDA5Nzk2NC40MDgzOTcsInN1YiI6IjY3MWYzMjRkOWZmNjgxZDllMGE0OTEwYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.i9uuGVvRIZncrahYKx68rOpxKrcuQ1_8VjeumPNbolw'
    }
  };

export const  apiKey=  "AIzaSyCB02NTJMKa7GAZ9msKTOdagEsPAlCh-3M";

export const authDomain = "streamgenie-f2ec1.firebaseapp.com";

export const projectId = "streamgenie-f2ec1";

export const storageBucket = "streamgenie-f2ec1.appspot.com";

export const messagingSenderId = "273655889307";

export const appId = "1:273655889307:web:56a99ff897dd2517a7b53e";

export const measurementId = "G-4J3N1BRNTD"

export const OPEN_API_KEY = "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";


export const GEMINI_API_KEY = "AIzaSyAlPcxswPofuWCkUbHSZduxnzRXx0AKR6g";